import { render, staticRenderFns } from "./ClientPortalPaymentQrSettings.vue?vue&type=template&id=be72f994&scoped=true"
import script from "./ClientPortalPaymentQrSettings.vue?vue&type=script&lang=ts"
export * from "./ClientPortalPaymentQrSettings.vue?vue&type=script&lang=ts"
import style0 from "./ClientPortalPaymentQrSettings.vue?vue&type=style&index=0&id=be72f994&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be72f994",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be72f994')) {
      api.createRecord('be72f994', component.options)
    } else {
      api.reload('be72f994', component.options)
    }
    module.hot.accept("./ClientPortalPaymentQrSettings.vue?vue&type=template&id=be72f994&scoped=true", function () {
      api.rerender('be72f994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/ClientPortalPaymentQrSettings.vue"
export default component.exports